import React from 'react';
import {
  Card,
  CardBody,
  Heading,
  VStack,
  Text,
  Divider,
  HStack
} from '@chakra-ui/react';
import { INPUT_FIELD_TYPE } from '@components/DynamicFormField/constant';
import { Field, CurrencyAccordion, AddCurrencyBar } from './components';

export const CustomRatesCard = ({ data, isEditMode, onChange, onCurrencyChange, onAddCurrency }) => {
  return (
    <Card bg="backGround" borderColor="brand.500" borderWidth="2px" shadow="xl">
      <CardBody>
        <VStack alignItems="stretch" gap={2}>
          <Heading size="md" color="colorPrimary">Custom Rates</Heading>
          <Text fontSize="xs" color="gray.400">Configure custom FX rates</Text>
          <Divider borderColor="whiteAlpha.300" />

          {/* Add Currency */}
          <HStack justify="space-between">
            <Text fontSize="sm" fontWeight="semibold" color="gray.300">Currencies</Text>
            {isEditMode && <AddCurrencyBar onAdd={(c) => onAddCurrency('customRates', c)} existingCurrencies={data.currencies} />}
          </HStack>

          <CurrencyAccordion
            currencies={data.currencies}
            isEditMode={isEditMode}
            renderFields={(currency, currencyData) => (
              <>
                <Field
                  field={{ name: 'enabled', label: 'Enabled', fieldType: INPUT_FIELD_TYPE.SWITCH }}
                  value={currencyData.enabled ?? false}
                  editable={isEditMode}
                  onChange={(e) =>
                    onCurrencyChange('customRates', currency, 'enabled', e.target.checked)
                  }
                />

                <Field
                  field={{
                    name: 'fxRate',
                    label: 'FX Rate',
                    fieldType: INPUT_FIELD_TYPE.INPUT,
                    inputType: 'number'
                  }}
                  value={currencyData.fxRate ?? ''}
                  editable={isEditMode}
                  onChange={(e) => {
                    const val = e.target.value;
                    // Keep raw value to allow intermediate states like "0.", "0.0", etc.
                    onCurrencyChange('customRates', currency, 'fxRate', val === '' ? 0 : val);
                  }}
                />
              </>
            )}
          />
        </VStack>
      </CardBody>
    </Card>
  );
};
